import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Backdrop,
} from "@mui/material";

import FinanceApprovalPageHeader from "views/pages/manage/unAssigned/studentFinanceApproval/components/ApprovalPageHeader.jsx";
import ALoader from "views/pages/manage/common/a-loader";

import { ReactComponent as Uparrow } from "assets/img/svg/upwardArrow.svg";
import UserAnalytics from "./UserAnalytics";
import UserListing from "./UserListing";
import UserLogs from "./UserLogs";
import { fetchOnInitialLand, getEmployeeDetailLogs } from "./helper";

const ManageEmployees = ({ userPermissions }) => {
  const [isLogsExpanded, setIsLogsExpanded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [userAnalytics, setUserAnalytics] = useState({
    honoEmployeeCount: 0,
    totalEmployeeCount: 0,
    totalEmployeeWithUserCount: 0,
    employeeNeedAccess: 0,
  });
  const [userList, setUserList] = useState([]);
  const [currPage, setCurrPage] = useState(0); //user listing page
  const [totalRows, setTotalRows] = useState(0); //total users records

  const [userLogs, setUserLogs] = useState([]);
  const [currentPageOnLogsTable, setCurrentPageOnLogsTable] = useState(0); //log current page
  const [totalLogsRows, setLogsRows] = useState(0); //total logs records

  useEffect(() => {
    const onInitialRender = async () => {
      setIsLoading(true);
      const data = await fetchOnInitialLand();

      const { userAnalytics, userList, userLogs } = data;
      setUserAnalytics(userAnalytics);
      populateUserListing(userList);
      populateLogsTable(userLogs);

      setIsLoading(false);
    };

    onInitialRender();
  }, []);

  const populateLogsTable = (response) => {
    const {
      empoloyeeLogDetailList = [],
      currentPage = 0,
      totalRecords = 0,
    } = response;
    setUserLogs(empoloyeeLogDetailList);
    setCurrentPageOnLogsTable(currentPage);
    setLogsRows(totalRecords);
  };

  const onLogsPageChange = async (page) => {
    setIsLoading(true);
    const response = await getEmployeeDetailLogs(page);
    populateLogsTable(response);

    setIsLoading(false);
  };

  const populateUserListing = (response) => {
    const {
      employeeDataList = [],
      currentPage = 0,
      totalRecords = 0,
    } = response;

    setUserList(employeeDataList);
    setCurrPage(currentPage);
    setTotalRows(totalRecords);
  };

  return (
    <div className="pb-4">
      <FinanceApprovalPageHeader
        heading={"Users and employees"}
        subHeading={"Here you can manage users and employees"}
      />

      <UserAnalytics userAnalytics={userAnalytics} />

      <UserListing
        rows={userList}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        currentPage={currPage}
        rowCount={totalRows}
        populateUserListing={populateUserListing}
        userPermissions={userPermissions}
      />

      <Accordion
        expanded={isLogsExpanded}
        onChange={() => {
          setIsLogsExpanded(!isLogsExpanded);
        }}
        className="m-3"
      >
        <AccordionSummary
          expandIcon={<Uparrow />}
          aria-controls="user-logs-content"
          id="user-logs-header"
        >
          <span className="heading-3 color-black-60 text-bold">Logs</span>
        </AccordionSummary>
        <AccordionDetails>
          <UserLogs
            rows={userLogs}
            isLoading={isLoading}
            rowCount={totalLogsRows}
            currentPage={currentPageOnLogsTable}
            onPageChange={onLogsPageChange}
          />
        </AccordionDetails>
      </Accordion>

      {isLoading && (
        <Backdrop
          open={isLoading}
          sx={(theme) => ({
            color: "#fff",
            zIndex: 2300,
          })}
        >
          <ALoader />
        </Backdrop>
      )}
    </div>
  );
};

export default ManageEmployees;
